// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 배너 높이만큼 화면을 내림(사이드 메뉴가 position: fixed 라 같이 내림) */
body.support-mode {
  padding-top: 36px;
}
body.support-mode aside.sidenav {
  top: 36px !important;
  height: calc(100vh - 36px) !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
